import axios from "axios";

const getMethod = async (url:string, headers:any)=> {
    axios.defaults.withCredentials = true;
    let response = await axios.get(url,headers)
        .then(function (response) {
            return response;
        })
        .catch(function (error){
            return error;
        })
    return response
}

const postMethod = async (url:string,params:any, headers:any,)=> {
    axios.defaults.withCredentials = true;
    let response = await axios.post(url,params,headers)
        .then(function (response) {
            return response;
        })
        .catch(function (error){
            return error;
        })
    return response
}

export {getMethod, postMethod}